// hooks/useThemeMessageListener.ts
import { useEffect } from 'react';
import { useTheme } from './ThemeContext';

export const useThemeMessageListener = () => {
    const { updateTheme } = useTheme();

    useEffect(() => {
        const handleMessage = (event: MessageEvent) => {
            // Verify origin for security
            if (event.origin !== window.location.origin) {
                return;
            }

            // Check if it's a theme update message
            if (event.data && event.data.type === 'UPDATE_THEME') {
                updateTheme(event.data.theme);
            }
        };

        // Add event listener
        window.addEventListener('message', handleMessage);

        // Cleanup
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, [updateTheme]);
};